import { render, staticRenderFns } from "./index.vue?vue&type=template&id=140967b4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiFormProgress: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Form/Progress.vue').default,UiAlert: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Alert.vue').default,UiForm: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Form/index.vue').default,UiSpinner: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Spinner/index.vue').default})
